import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { Row, Col, Button } from "react-bootstrap";
import {
    FaArrowLeft,
    FaFileExcel,
    FaFilePdf,
    FaIdCard,
    FaMoneyCheckAlt,
    FaUniversity,
} from "react-icons/fa";

// Img
import imgPayments from "../../../../../../assets/image/payments/pay-supplier.png";
import imgAdd from "../../../../../../assets/image/payments/imgPay.png";

// Components
import { HeaderImage } from "../../../../shared/header_image/HeaderImage";
import { Loading } from "../../../../shared/loading/Loading";
import AlertComponent from "../../../../../../helpers/alert/AlertComponent";

// Services
import { paymentServices } from "../../../../../../helpers/services/PaymentServices";
import { filesServices } from "../../../../../../helpers/services/FilesServices";

// Enums
import { ReportTypePaymentsEnum, ResponseStatusEnum } from "../../../../../../helpers/GlobalEnum";

export const CollectionAccountDetails = () => {
    const params = useParams();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [informationLoadingText, setInformationLoadingText] = useState("");
    const [accountInformation, setAccountInformation] = useState(null);

    const getAccountInformaction = async (accountId) => {
        setLoading(true);
        try {
            setInformationLoadingText("Obteniendo información");
            const { data, status } = await paymentServices.getCollectionAccountsById(accountId);
            if (status === ResponseStatusEnum.OK) {
                setAccountInformation(data);
            }
        } catch (error) {
            console.error("Error obteniendo las entregas:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleViewFile = async (pdfUrl) => {
        if (!pdfUrl) {
            AlertComponent.error('Error', 'No hay un archivo cargado para esta entrega.');
            return;
        }

        try {
            setLoading(true);
            setInformationLoadingText("Obteniendo archivo");

            const { blob, status } = await filesServices.downloadFile(pdfUrl?.url_descarga);

            if (status === ResponseStatusEnum.OK && blob) {
                const file = new Blob([blob], { type: "application/pdf" });
                const fileURL = URL.createObjectURL(file);
                window.open(fileURL, '_blank');
            } else if (status === ResponseStatusEnum.NOT_FOUND) {
                AlertComponent.error('Error', 'No se puede descargar el archivo.');
            }
        } catch (error) {
            console.error("Error al descargar archivo:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleGenerateDocument = async (SPId, reportType) => {
        try {
            setLoading(true);
            setInformationLoadingText("Generando documento");

            const { status, blob, type, filename, data } = await paymentServices.getExcelAndPdfFile(SPId, reportType);
            console.log(blob, status);

            if (status === ResponseStatusEnum.OK && blob) {
                const fileURL = URL.createObjectURL(blob);
                // Si es PDF y quieres abrir en otra pestaña:
                if ((type).includes('pdf')) {
                    window.open(fileURL, '_blank');
                } else {
                    // Descarga (Excel u otros binarios)
                    const a = document.createElement('a');
                    a.href = fileURL;
                    a.download = filename || 'reporte.xlsx';
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                }

                // Limpia el ObjectURL
                setTimeout(() => URL.revokeObjectURL(fileURL), 1000);
            } else if (status === ResponseStatusEnum.NOT_FOUND || !blob) {
                AlertComponent.error('Error', 'No se puede descargar el archivo.');
            }
        } catch (error) {
            console.error("Error al Generar documento PDF para cuenta:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleChangeStatusAccount = async (SPId) => {
        try {
            setLoading(true);
            setInformationLoadingText("Validando entregas y pago");
            const {data, status} = await paymentServices.changeStatusCollectionAccountDetail(SPId);
            console.log(data);
            if (status === ResponseStatusEnum.OK) {
                AlertComponent.success(data.mensaje);
                navigate(`/admin/fiduciary/list-account-suppliers`);
            }

            if (status === ResponseStatusEnum.BAD_REQUEST) {
                AlertComponent.error(data.detail);
            }
        } catch (error) {
            console.error("Error obteniendo las entregas:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (params.id) {
            getAccountInformaction(params.id);
        }
    }, [params.id]);

    return (
        <>
            <HeaderImage
                imageHeader={imgPayments}
                titleHeader={'Detalle cuenta de cobro'}
                bannerIcon={imgAdd}
                backgroundIconColor={'#2148C0'}
                bannerInformation={'Aquí podrás revisar el detalle de la cuenta de cobro enviada por el proveedor.'}
                backgroundInformationColor={'#40A581'}
            />

            {loading && <Loading fullScreen text={informationLoadingText} />}

            {accountInformation && (
                <div className="content-collection-details collection-details">
                    <div className="collection-summary-grid">
                        <div className="collection-summary-card">
                            <div className="collection-summary-card__title">Proveedor</div>
                            <div className="collection-summary-card__row"><strong>Nombre:</strong> {accountInformation?.proveedor.nombre}</div>
                            <div className="collection-summary-card__row"><strong>NIT:</strong> {accountInformation?.proveedor.nit}</div>
                            <div className="collection-summary-card__row"><strong>Cuenta N°:</strong> {accountInformation?.cuenta_cobro.numero}</div>
                        </div>
                        <div className="collection-summary-card">
                            <div className="collection-summary-card__title">Cuenta bancaria</div>
                            <div className="collection-summary-card__row"><strong>Entidad:</strong> {accountInformation?.banco?.entidad_bancaria}</div>
                            <div className="collection-summary-card__row"><strong>Número:</strong> {accountInformation?.banco?.numero_cuenta}</div>
                        </div>
                        <div className="collection-summary-card collection-summary-card--highlight">
                            <div className="collection-summary-card__title">Total</div>
                            <div className="collection-summary-card__value">
                                ${(() => {
                                    const valorFETotal = Number(accountInformation?.cuenta_cobro.valor_total_factura_electronica || 0);
                                    const valorTotal = Number(accountInformation?.cuenta_cobro.valor_total || 0);
                                    return (valorFETotal > 0 ? valorFETotal : valorTotal).toLocaleString('es-CO');
                                })()}
                            </div>
                        </div>
                    </div>

                    <div className="collection-summary-grid2">
                        <div className="collection-summary-card">
                            <h5 className="section-title">Consolidado de documentos</h5>
                            <div className="collection-details__downloads">
                                <button className="button-download-collection button-download--primary" onClick={() => handleViewFile(accountInformation?.archivos.certificado_bancario)}>
                                    <FaUniversity /> Certificado bancario
                                </button>
                                <button className="button-download-collection button-download--success" onClick={() => handleViewFile(accountInformation?.archivos.rut)}>
                                    <FaIdCard /> RUT
                                </button>
                                <button className="button-download-collection button-download--warning" onClick={() => handleGenerateDocument(accountInformation?.cuenta_cobro.numero, ReportTypePaymentsEnum.EXCEL)}>
                                    <FaFileExcel /> Generar documento excel
                                </button>
                                <button className="button-download-collection button-download--info" onClick={() => handleGenerateDocument(accountInformation?.cuenta_cobro.numero, ReportTypePaymentsEnum.PDF)}>
                                    <FaFilePdf /> Generar documento pdf
                                </button>
                            </div>
                        </div>

                        <div className="collection-summary-card">
                            <h5 className="section-title">Entregas</h5>
                            {accountInformation?.detalles.map((item, idx) => (
                                <div key={idx} className="revision-box">
                                    <div>
                                        <strong>N°:</strong> {item?.entrega?.id} &nbsp;
                                        <strong>CUB:</strong> {item?.entrega?.cub} &nbsp;
                                        <strong>Identificación:</strong> {item?.entrega?.numero_documento_beneficiario} &nbsp;
                                        <strong>Valor:</strong> $ {parseFloat(item.valor_factura_electronica > 0 ? item.valor_factura_electronica : item.valor).toLocaleString('es-CO')}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    <Row className="justify-content-center collection-actions g-3">
                        <Col xs="12" md="auto" className="d-flex justify-content-center">
                            <Button className="collection-actions__btn" variant="outline-warning" onClick={() => handleChangeStatusAccount(accountInformation?.cuenta_cobro?.id)}>
                                <FaMoneyCheckAlt /> Emitir para pago
                            </Button>
                        </Col>
                        <Col xs="12" md="auto" className="d-flex justify-content-center mb-3 mb-md-0">
                            <button className="collection-actions__btn collection-actions__btn--ghost" onClick={() => navigate(-1)}>
                                <FaArrowLeft /> Cuentas de cobro
                            </button>
                        </Col>
                    </Row>
                </div>
            )}
        </>
    );
};



